import { render, staticRenderFns } from "./ReportsPreview.vue?vue&type=template&id=9ff4b88c&scoped=true&"
import script from "./ReportsPreview.vue?vue&type=script&lang=js&"
export * from "./ReportsPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReportsPreview.vue?vue&type=style&index=0&id=9ff4b88c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff4b88c",
  null
  
)

export default component.exports